import * as config from "src/config/config";
import { useStores } from "src/components/common/utils/useStore";
import { checkValue } from "src/components/common/utils/functions";
const urlPattern = config.config.media_store_url;

export const mediaStudioBaseUrl = () => {
  const {
    cpcmslitefeed: { cpCmsLitePageData, spotlightPageData },
  } = useStores();

  const mainUrl = checkValue(cpCmsLitePageData?.mainUrl)
    ? cpCmsLitePageData?.mainUrl
    : checkValue(spotlightPageData?.mainUrl)
    ? spotlightPageData?.mainUrl
    : "";

  return urlPattern.replace("{page_name}", mainUrl);
};
